import { render, staticRenderFns } from "./IosSVG.vue?vue&type=template&id=0161f3a0&"
import script from "./IosSVG.vue?vue&type=script&lang=js&"
export * from "./IosSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports